/**
 * config/sync/syncInit.config.ts
 * Configuration constants for sync initialization
 *
 * Centralized configuration for timeout and retry behavior.
 * Exported as constants (not inline literals) for testability.
 */

/**
 * Timeout for provider connection checks (10 seconds)
 *
 * Applied to provider.isConnected() calls to prevent hangs.
 * Timeout triggers PROVIDER_OUTAGE reason.
 */
export const SYNC_INIT_TIMEOUT_MS = 10_000;

/**
 * Exponential backoff delays for retries (milliseconds)
 *
 * Used by Task 2.F retry logic for OFFLINE and PROVIDER_OUTAGE errors.
 * Array length determines max retry attempts.
 *
 * Example: [5s, 10s, 20s, 40s] = 4 retry attempts with exponential backoff
 */
export const SYNC_INIT_BACKOFF_MS = [5_000, 10_000, 20_000, 40_000];

/**
 * Maximum retry attempts
 *
 * Derived from SYNC_INIT_BACKOFF_MS array length for consistency.
 */
export const SYNC_INIT_MAX_RETRIES = SYNC_INIT_BACKOFF_MS.length;
